// Utility to handle image URL resolution with fallback support
export const getImageUrl = (imagePath, fallback = '/api/placeholder-image.jpg') => {
  if (!imagePath) return getFallbackImage(fallback);
  
  // If it's already a full URL (starts with http/https), return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If it's a relative path starting with / (including /api/uploads), prepend backend URL
  if (imagePath.startsWith('/')) {
    const backendUrl = window.location.origin || 'http://localhost:8001';
    return `${backendUrl}${imagePath}`;
  }
  
  // Otherwise return as is
  return imagePath;
};

// Get fallback image URL
export const getFallbackImage = (type = 'default') => {
  const backendUrl = window.location.origin || 'http://localhost:8001';
  
  switch(type) {
    case 'portfolio':
      return `${backendUrl}/api/placeholder/portfolio.jpg`;
    case 'blog':
      return `${backendUrl}/api/placeholder/blog.jpg`;
    case 'hero':
      return `${backendUrl}/api/placeholder/hero.jpg`;
    default:
      return `${backendUrl}/api/placeholder/default.jpg`;
  }
};

// Handle image load errors with fallback
export const handleImageError = (event, fallback = 'default') => {
  event.target.src = getFallbackImage(fallback);
  event.target.onerror = null; // Prevent infinite loop
};